import { httpServiceClient } from '@/infra/http'

import { formatUpgradeRequestList } from './upgrade-service-utils'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { EnrollmentStatusTab } from '@/domain/models/enrollment/status'
import {
  UpgradeCreateRequest,
  UpgradeCreateResponse,
  UpgradeEnrollmentQuery,
  UpgradeEnrollmentResponse,
  UpgradePendingRequest
} from './upgrade-service-types'

const getUpgradeRequestUrl = (companyId: string) => makeApiUrl(`/customer/v1/company/${companyId}`)

export const createUpgradeRequestService = (client = httpServiceClient) => ({
  async fetchPendingRequests(companyId: string) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request/pending`

    const response = await client<UpgradePendingRequest>({
      method: 'get',
      url: pathUrl
    })

    return response.body.data as UpgradePendingRequest
  },

  async createRequest(companyId: string, payload: UpgradeCreateRequest) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request`

    const response = await client<UpgradeCreateResponse>({
      method: 'post',
      url: pathUrl,
      body: {
        plan: payload.planId
      }
    })

    return response.body.data as UpgradeCreateResponse
  },

  async cancelRequest(companyId: string, requestUuid: string) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request/${requestUuid}/cancel`

    await client<void>({
      method: 'put',
      url: pathUrl
    })
  },

  async fetchRequestList(companyId: string, payload: UpgradeEnrollmentQuery) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request`

    const response = await client<UpgradeEnrollmentResponse>({
      method: 'get',
      url: pathUrl,
      params: {
        page: String(payload.page ?? 1),
        pageSize: String(payload.pageSize ?? 10),
        status: payload.status || EnrollmentStatusTab.WAITING_HR,
        search: payload.search || undefined
      }
    })

    return formatUpgradeRequestList(response.body?.data as UpgradeEnrollmentResponse)
  },

  async approveRequest(companyId: string, requestUuid: string, chargeType: string) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request/${requestUuid}/approve`

    await client<void>({
      method: 'put',
      url: pathUrl,
      body: {
        charge_type: chargeType
      }
    })
  },

  async rejectRequest(companyId: string, requestUuid: string, reason: string) {
    const pathUrl = `${getUpgradeRequestUrl(companyId)}/upgrade-request/${requestUuid}/reject`

    await client<void>({
      method: 'put',
      url: pathUrl,
      body: { reason }
    })
  }
})

export const upgradeRequestService = createUpgradeRequestService()
